import instance from "../axios/axios.config";
const { provision } = instance;

export const addAftApi = async (payload) => {
    try {
        const response = await provision.post(`/aft`, payload)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getAllAftApi = async () => {
    try {
        const response = await provision.get(`/aft`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getAllAftNamesApi = async () => {
    try {
        const response = await provision.get(`/aws_services/accounts`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const getAllOrgsApi = async () => {
    try {
        const response = await provision.get(`/aws_services/organizational-units`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}